import { api } from '@/shared/lib/axios.ts';
import type {
  AdminUserRow,
  AdminUserListResponse,
  AdminUserListParams,
  AdminPerfil,
} from '@/shared/types/admin-user.ts';

export async function listAdminUsers(params: AdminUserListParams): Promise<AdminUserListResponse> {
  const { data } = await api.get<AdminUserListResponse>('/admin/users', { params });
  return data;
}

export async function getAdminUser(id: string): Promise<AdminUserRow> {
  const { data } = await api.get<AdminUserRow>(`/admin/users/${id}`);
  return data;
}

export interface CreateAdminUserDTO {
  email: string;
  nome: string;
  perfil: AdminPerfil;
  recebeNotificacoes: boolean;
  phone?: string;
}

export async function createAdminUser(input: CreateAdminUserDTO): Promise<AdminUserRow> {
  const { data } = await api.post<AdminUserRow>('/admin/users', input);
  return data;
}

export interface UpdateAdminUserDTO {
  nome?: string;
  perfil?: AdminPerfil;
  isActive?: boolean;
  recebeNotificacoes?: boolean;
  phone?: string;
}

export async function updateAdminUser(id: string, input: UpdateAdminUserDTO): Promise<AdminUserRow> {
  const { data } = await api.put<AdminUserRow>(`/admin/users/${id}`, input);
  return data;
}

export async function deleteAdminUser(id: string): Promise<AdminUserRow> {
  const { data } = await api.delete<AdminUserRow>(`/admin/users/${id}`);
  return data;
}
